import React, { useState } from 'react';
import ContactModal from '../components/ContactModal';

const RED = '#bf1e2e';
const NAVY = '#014c8d';
const BG = '#080d16';
const SURFACE = '#0d1525';
const BORDER = 'rgba(255,255,255,0.08)';
const DIM = 'rgba(255,255,255,0.45)';
const TEXT = '#f0f4ff';
const TEXT2 = 'rgba(255,255,255,0.7)';

const programs = [
  {
    id: 1,
    code: 'P01',
    name: 'Behavioural Program',
    weeks: 8,
    phases: 4,
    phaseLabel: 'stages',
    tagline: 'Discover your identity, strengths, and what you carry beyond sport.',
    description: 'The foundation of your BTHD journey. Four stages that help you understand who you are as an athlete, where your strengths live, and what kind of leader you are becoming.',
    phases_list: [
      'Athlete Assessment',
      'Skills & Pathways',
      'Leadership Development',
      'Lasting Impact',
    ],
    access: 'Available with institutional access',
    accessColor: 'rgba(255,255,255,0.7)',
    tier: 'starter',
    locked: false,
    accentColor: RED,
    taskCount: 40,
    statsLine: '4 stages · 2 weeks per stage · 5 tasks/week · 40 tasks total',
  },
  {
    id: 2,
    code: 'P02',
    name: 'Post-Sport Development',
    weeks: 15,
    phases: 5,
    phaseLabel: 'phases',
    tagline: 'Build your life and mindset after competition ends.',
    description: 'For athletes navigating identity, purpose, and belonging after the final whistle. Five phases to help you redefine who you are, rebuild structure, and step into your next chapter with clarity.',
    phases_list: [
      'Redefining Who You Are',
      'Discovering Who You Are Without Sport',
      'Rebuilding Purpose and Daily Structure',
      'Relationships, Community and Belonging',
      'Defining Legacy and Next Chapter',
    ],
    access: 'Available on Pro and Elite plans',
    accessColor: 'rgba(255,255,255,0.7)',
    tier: 'pro',
    locked: true,
    accentColor: RED,
    taskCount: 45,
    statsLine: '5 phases · 3 weeks per phase · 3 tasks/week · 45 tasks total',
  },
  {
    id: 3,
    code: 'P03',
    name: 'Career Development',
    weeks: 15,
    phases: 5,
    phaseLabel: 'phases',
    tagline: 'Translate your athlete skills into a professional career.',
    description: 'A structured 15-week career development program built specifically for former athletes. From skills audit to first 90 days, every tool you need to enter the professional world with confidence.',
    phases_list: [
      'Auditing Transferable Skills and Athlete Brand',
      'Industry Mapping and Career Pathway Selection',
      'Resume, LinkedIn and Professional Positioning',
      'Networking, Outreach and Interview Preparation',
      'Offer Evaluation, Negotiation and First 90 Days',
    ],
    access: 'Available on Elite plan',
    accessColor: 'rgba(255,255,255,0.7)',
    tier: 'elite',
    locked: true,
    accentColor: RED,
    taskCount: 45,
    statsLine: '5 phases · 3 weeks per phase · 3 tasks/week · 45 tasks total',
  },
  {
    id: 4,
    code: 'P04',
    name: 'Financial Literacy',
    weeks: 15,
    phases: 5,
    phaseLabel: 'phases',
    tagline: 'Understand your relationship with money and build the habits that protect your future.',
    description: 'A 15-week behavioral reflection program built for athletes navigating income transition. Five phases covering your money beliefs, financial reality, structure, protection, and what wealth really means to you. Reflection only, not financial advice.',
    phases_list: [
      'Your Relationship With Money',
      'Understanding What You Have',
      'Building Financial Structure',
      "Protecting What You've Built",
      'Wealth Beyond the Game',
    ],
    access: 'Available on Elite plan',
    accessColor: 'rgba(255,255,255,0.7)',
    tier: 'elite',
    locked: true,
    accentColor: RED,
    taskCount: 40,
    statsLine: '5 phases · 3 weeks per phase · 8 tasks/phase · 40 tasks total',
    disclaimer: 'Reflection and self-discovery only. Not financial advice.',
  },
];

export default function ProgramsPage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <div style={{
      minHeight: '100vh',
      background: BG,
      fontFamily: "'Barlow', -apple-system, BlinkMacSystemFont, sans-serif",
      color: TEXT,
    }}>
      {/* Nav */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(10,15,26,0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${BORDER}`,
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 48px', height: 72,
        }} className="programs-nav">
          <a href="/" style={{ textDecoration: 'none', flexShrink: 0 }}>
            <img
              src="https://www.bthd.app/bthd-email-sig-300x80-transparent.png"
              alt="Bigger Than Hoop Dreams"
              style={{ height: 36, width: 'auto', filter: 'brightness(0) invert(1)' }}
            />
          </a>
          <div className="programs-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
            <a href="/" style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4 }}>Home</a>
            <a href="/about.html" style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4 }}>About</a>
            <a href="/programs" style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4 }}>Programs</a>
            <a href="/workshop" style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4 }}>Workshop</a>
            <a href="/early-pathways-program" style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4 }}>Early Pathways</a>
            <button onClick={() => setContactOpen(true)} style={{ background: 'none', border: 'none', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', textDecoration: 'none', letterSpacing: 0.4, cursor: 'pointer', padding: 0, fontFamily: 'inherit' }}>Contact</button>
            <a href="/admin/login" style={{
              background: RED, color: '#fff', borderRadius: 8,
              padding: '10px 20px', fontSize: 13, fontWeight: 700,
              textDecoration: 'none', letterSpacing: 0.3, whiteSpace: 'nowrap',
            }}>Access Portal →</a>
          </div>
          <button
            className="programs-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              display: 'none', background: 'none', border: 'none',
              cursor: 'pointer', padding: '8px', flexDirection: 'column',
              gap: 5, alignItems: 'center', justifyContent: 'center',
            }}
          >
            <span style={{ display: 'block', width: 22, height: 2, background: menuOpen ? 'rgba(255,255,255,0.4)' : '#fff', borderRadius: 2, transition: 'all 0.2s', transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
            <span style={{ display: 'block', width: 22, height: 2, background: '#fff', borderRadius: 2, opacity: menuOpen ? 0 : 1, transition: 'all 0.2s' }} />
            <span style={{ display: 'block', width: 22, height: 2, background: menuOpen ? 'rgba(255,255,255,0.4)' : '#fff', borderRadius: 2, transition: 'all 0.2s', transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
          </button>
        </div>
        {menuOpen && (
          <div style={{
            borderTop: `1px solid ${BORDER}`,
            padding: '16px 24px 24px',
            display: 'flex', flexDirection: 'column', gap: 4,
          }}>
            <a href="/" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${BORDER}` }}>Home</a>
            <a href="/about.html" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${BORDER}` }}>About</a>
            <a href="/programs" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${BORDER}` }}>Programs</a>
            <a href="/workshop" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${BORDER}` }}>Workshop</a>
            <a href="/early-pathways-program" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${BORDER}` }}>Early Pathways</a>
            <button onClick={() => { setMenuOpen(false); setContactOpen(true); }} style={{ background: 'none', border: 'none', borderBottom: `1px solid ${BORDER}`, color: 'rgba(255,255,255,0.8)', fontSize: 16, fontWeight: 600, textDecoration: 'none', padding: '12px 0', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', width: '100%' }}>Contact</button>
            <a href="/admin/login" style={{
              background: RED, color: '#fff', borderRadius: 8,
              padding: '14px 20px', fontSize: 15, fontWeight: 700,
              textDecoration: 'none', textAlign: 'center', marginTop: 8,
            }}>Access Portal →</a>
          </div>
        )}
      </nav>

      {/* Hero */}
      <div style={{
        padding: '80px 40px 64px',
        maxWidth: 960, margin: '0 auto',
        textAlign: 'center',
        position: 'relative',
      }} className="programs-hero">
        <div style={{
          position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
          width: 600, height: 300,
          background: `radial-gradient(ellipse, ${RED}18 0%, transparent 70%)`,
          pointerEvents: 'none',
        }} />
        <h1 style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontSize: 'clamp(44px, 6vw, 72px)',
          fontWeight: 900, lineHeight: 1.0,
          color: TEXT, textTransform: 'uppercase',
          letterSpacing: -1, margin: '0 0 20px',
        }}>
          Everything athletes need,<br />
          from identity to financial readiness.
        </h1>
        <p style={{
          fontSize: 18, color: TEXT2, maxWidth: 560,
          margin: '0 auto 16px', lineHeight: 1.7,
        }}>
          Four programs, designed to support your athlete development journey.
        </p>
        <p style={{
          fontSize: 12, color: 'rgba(255,255,255,0.3)', maxWidth: 480,
          margin: '0 auto 48px', lineHeight: 1.6,
        }}>
          Financial Literacy content is for reflection and self-discovery only. Not financial advice.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {['8–15 Weeks Per Program', '40–45 Tasks', 'Athlete-Specific', 'Institutional + Individual'].map(tag => (
            <div key={tag} style={{
              padding: '6px 14px', borderRadius: 6,
              border: `1px solid ${BORDER}`,
              fontSize: 12, fontWeight: 700, color: DIM, letterSpacing: 0.5,
            }}>{tag}</div>
          ))}
        </div>
      </div>

      {/* Program cards */}
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        padding: '0 40px 80px',
        display: 'flex', flexDirection: 'column', gap: 32,
      }} className="programs-cards">
        {programs.map((prog, i) => (
          <div
            key={prog.id}
            style={{
              background: SURFACE,
              border: `1px solid ${BORDER}`,
              borderTop: `3px solid ${prog.accentColor}`,
              borderRadius: 16,
              overflow: 'hidden',
            }}
          >
            <div style={{
              display: 'flex', gap: 0,
              flexWrap: 'wrap',
            }}>
              {/* Left: main info */}
              <div style={{ flex: '1 1 420px', padding: '36px 40px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                  <div style={{
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontSize: 11, fontWeight: 900, letterSpacing: 2,
                    color: prog.accentColor,
                    background: `${prog.accentColor}18`,
                    border: `1px solid ${prog.accentColor}44`,
                    borderRadius: 4, padding: '3px 10px',
                    textTransform: 'uppercase',
                  }}>{prog.code}</div>
                  <div style={{
                    fontSize: 11, fontWeight: 700, letterSpacing: 1,
                    color: 'rgba(255,255,255,0.7)',
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 4, padding: '3px 10px',
                    textTransform: 'uppercase',
                  }}>{prog.access}</div>
                </div>

                <h2 style={{
                  fontFamily: "'Barlow Condensed', sans-serif",
                  fontSize: 36, fontWeight: 900,
                  color: TEXT, lineHeight: 1.05,
                  textTransform: 'uppercase',
                  letterSpacing: -0.5, margin: '0 0 10px',
                }}>{prog.name}</h2>

                <p style={{
                  fontSize: 17, color: 'rgba(255,255,255,0.6)',
                  fontWeight: 700, margin: '0 0 16px', lineHeight: 1.4,
                  fontStyle: 'italic',
                }}>"{prog.tagline}"</p>

                <p style={{
                  fontSize: 14, color: TEXT2,
                  lineHeight: 1.7, margin: '0 0 28px',
                }}>{prog.description}</p>

                <div style={{ display: 'flex', gap: 16, marginBottom: 28, flexWrap: 'wrap' }}>
                  {[
                    { label: 'Duration', value: `${prog.weeks} weeks` },
                    { label: 'Structure', value: `${prog.phases} ${prog.phaseLabel}` },
                    { label: 'Tasks', value: `${prog.taskCount} tasks` },
                  ].map(({ label, value }) => (
                    <div key={label} style={{
                      padding: '10px 16px',
                      background: `${prog.accentColor}10`,
                      border: `1px solid ${prog.accentColor}25`,
                      borderRadius: 8,
                    }}>
                      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 2, color: prog.accentColor, textTransform: 'uppercase', marginBottom: 3 }}>{label}</div>
                      <div style={{ fontSize: 14, fontWeight: 800, color: TEXT }}>{value}</div>
                    </div>
                  ))}
                </div>

                {prog.locked ? (
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    <a
                      href="/programs/request-access"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px', borderRadius: 10,
                        background: prog.accentColor, border: 'none',
                        color: '#fff', fontSize: 13, fontWeight: 800,
                        textDecoration: 'none', letterSpacing: 0.5,
                      }}
                    >Request Access</a>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    <a
                      href="/athlete/login"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px', borderRadius: 10,
                        background: RED, border: 'none',
                        color: '#fff', fontSize: 13, fontWeight: 800,
                        textDecoration: 'none', letterSpacing: 0.5,
                      }}
                    >Start Program →</a>
                    <a
                      href="/programs/request-access"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px', borderRadius: 10,
                        border: `1px solid ${BORDER}`,
                        color: TEXT2, fontSize: 13, fontWeight: 700,
                        textDecoration: 'none',
                      }}
                    >Request Access</a>
                  </div>
                )}
              </div>

              {/* Right: phase list */}
              <div style={{
                flex: '1 1 280px',
                padding: '32px 32px',
                borderLeft: `1px solid ${BORDER}`,
                display: 'flex', flexDirection: 'column', justifyContent: 'center',
              }}>
                <div style={{
                  fontSize: 10, fontWeight: 800, letterSpacing: 2,
                  color: DIM, textTransform: 'uppercase', marginBottom: 16,
                }}>
                  Program Outline
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {prog.phases_list.map((phase, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                      <div style={{
                        flexShrink: 0, width: 24, height: 24, borderRadius: 6,
                        background: `${prog.accentColor}18`,
                        border: `1px solid ${prog.accentColor}33`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontFamily: "'Barlow Condensed', sans-serif",
                        fontSize: 11, fontWeight: 900, color: prog.accentColor,
                        marginTop: 1,
                      }}>
                        {String(idx + 1).padStart(2, '0')}
                      </div>
                      <div style={{ fontSize: 13, color: TEXT2, lineHeight: 1.45, flex: 1 }}>{phase}</div>
                    </div>
                  ))}
                </div>
                <div style={{
                  marginTop: 20, padding: '10px 14px',
                  background: `${prog.accentColor}0c`,
                  border: `1px solid ${prog.accentColor}22`,
                  borderRadius: 8,
                  fontSize: 11, color: DIM, lineHeight: 1.5,
                }}>
                  {(prog as any).statsLine}
                </div>
                {(prog as any).disclaimer && (
                  <div style={{
                    marginTop: 10, padding: '8px 14px',
                    background: 'rgba(200,150,42,0.06)',
                    border: '1px solid rgba(200,150,42,0.2)',
                    borderRadius: 8,
                    fontSize: 11, color: 'rgba(200,150,42,0.7)', lineHeight: 1.5,
                  }}>
                    {(prog as any).disclaimer}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* How it works */}
      <div style={{
        maxWidth: 960, margin: '0 auto',
        padding: '0 40px 80px',
      }} className="programs-how">
        <div style={{
          background: SURFACE, border: `1px solid ${BORDER}`,
          borderRadius: 16, padding: '48px 48px',
          textAlign: 'center',
        }}>
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: 11, fontWeight: 800, letterSpacing: 3,
            color: RED, textTransform: 'uppercase', marginBottom: 16,
          }}>How Programs Work</div>
          <p style={{ fontSize: 15, color: TEXT2, maxWidth: 600, margin: '0 auto 36px', lineHeight: 1.7 }}>
            Program 01 unlocks one task per week across 4 stages. Programs 02, 03, and 04 unlock up to three tasks per week across 5 phases,
            building deeper and faster as you progress. Submit your response, advance to the next task,
            and build something that belongs to you.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, maxWidth: 700, margin: '0 auto' }} className="programs-how-grid">
            {[
              {
                icon: (
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={RED} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
                  </svg>
                ),
                title: 'Weekly Unlock',
                body: 'Each week a new task unlocks. P01: one task. P02 and P03: three tasks. The pace is intentional.',
              },
              {
                icon: (
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={RED} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 20h9"/>
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
                  </svg>
                ),
                title: 'Submit & Reflect',
                body: 'Write your response. Every answer becomes part of your permanent journey record.',
              },
              {
                icon: (
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={RED} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="20" x2="18" y2="10"/>
                    <line x1="12" y1="20" x2="12" y2="4"/>
                    <line x1="6" y1="20" x2="6" y2="14"/>
                    <line x1="2" y1="20" x2="22" y2="20"/>
                  </svg>
                ),
                title: 'Track Progress',
                body: 'Your institution and BTHD track progression across all phases and programs.',
              },
            ].map(({ icon, title, body }) => (
              <div key={title} style={{
                background: BG, border: `1px solid ${BORDER}`,
                borderRadius: 12, padding: '24px 20px',
              }}>
                <div style={{ marginBottom: 12 }}>{icon}</div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, color: TEXT, marginBottom: 6 }}>{title}</div>
                <div style={{ fontSize: 12, color: DIM, lineHeight: 1.6 }}>{body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Institution CTA */}
      <div style={{
        maxWidth: 960, margin: '0 auto',
        padding: '0 40px 100px',
      }} className="programs-cta">
        <div style={{
          background: `linear-gradient(135deg, ${NAVY}44 0%, ${RED}22 100%)`,
          border: `1px solid ${BORDER}`,
          borderRadius: 16, padding: '52px 48px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 32,
        }}>
          <div style={{ flex: 1, minWidth: 280 }}>
            <h2 style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: 32, fontWeight: 900, color: TEXT,
              textTransform: 'uppercase', letterSpacing: -0.5,
              margin: '0 0 12px', lineHeight: 1.1,
            }}>Representing an institution?</h2>
            <p style={{ fontSize: 14, color: TEXT2, lineHeight: 1.7, margin: 0, maxWidth: 420 }}>
              Schools, universities, sports organizations, and player associations can license
              BTHD for their entire athlete roster. We'll show you the platform, your dashboard,
              and build a proposal tailored to your athletes.
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, flexShrink: 0 }}>
            <a
              href="/programs/request-access"
              style={{
                display: 'inline-block',
                padding: '14px 32px', borderRadius: 10,
                background: RED, border: 'none',
                color: '#fff', fontSize: 14, fontWeight: 800,
                textDecoration: 'none', letterSpacing: 0.5,
                textAlign: 'center',
              }}
            >Request Access →</a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        borderTop: `1px solid ${BORDER}`,
        padding: '28px 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: 16,
      }} className="programs-footer">
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img src="https://www.bthd.app/bthd-email-sig-300x80-transparent.png" alt="BTHD" style={{ height: 18, width: 'auto', filter: 'brightness(0) invert(1)', opacity: 0.5 }} />
          <span style={{ fontSize: 12, color: DIM }}>Bigger Than Hoop Dreams Inc. · Kitchener, ON, Canada</span>
        </div>
        <div style={{ display: 'flex', gap: 20 }}>
          <a href="/" style={{ fontSize: 12, color: DIM, textDecoration: 'none' }}>Home</a>
          <a href="/athlete/login" style={{ fontSize: 12, color: DIM, textDecoration: 'none' }}>Athlete Login</a>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800;900&family=Barlow:wght@400;600;700;800&display=swap');
        * { box-sizing: border-box; }
        @media (max-width: 768px) {
          .programs-nav { padding: 0 20px !important; }
          .programs-nav-links { display: none !important; }
          .programs-hamburger { display: flex !important; }
          .programs-hero { padding: 48px 20px 40px !important; }
          .programs-hero h1 { font-size: clamp(36px, 10vw, 56px) !important; }
          .programs-hero p { font-size: 15px !important; }
          .programs-cards { padding: 0 16px 48px !important; }
          .programs-how { padding: 0 16px 48px !important; }
          .programs-how > div { padding: 32px 24px !important; }
          .programs-how-grid { grid-template-columns: 1fr !important; max-width: 100% !important; }
          .programs-cta { padding: 0 16px 60px !important; }
          .programs-cta > div { padding: 36px 24px !important; }
          .programs-footer { padding: 20px 16px !important; flex-direction: column !important; gap: 12px !important; }
        }
      `}</style>
      {contactOpen && <ContactModal onClose={() => setContactOpen(false)} />}
    </div>
  );
}
